// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O00xt","label":"styles_label__YGtQ9"};